import { render, staticRenderFns } from "./AccountLoader.vue?vue&type=template&id=12ad9ecc&"
import script from "./AccountLoader.vue?vue&type=script&lang=js&"
export * from "./AccountLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports